import { useTranslation } from 'react-i18next'
import { Select } from '@asus-common/fe-ui-shadcn'
import { SUPPORTED_LOCALES, type SupportedLocale } from '@/shared/lib/locale'
import { preloadActiveNamespaces } from '@/i18n'

interface LanguageOption {
  value: SupportedLocale
  labelKey: `footer.language.${SupportedLocale}`
}

const OPTIONS: LanguageOption[] = SUPPORTED_LOCALES.map(locale => ({
  value: locale,
  labelKey: `footer.language.${locale}` as const,
}))

interface LanguageSwitcherProps {
  className?: string
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation('auth-common')

  const current = (SUPPORTED_LOCALES as readonly string[]).includes(
    i18n.language,
  )
    ? (i18n.language as SupportedLocale)
    : 'pt-BR'

  const optionLabel = (option: LanguageOption) => t(option.labelKey)

  return (
    <Select<LanguageOption, SupportedLocale>
      options={OPTIONS}
      values={[current]}
      multiple={false}
      clearable={false}
      size="sm"
      className={className}
      getOptionValue={option => option.value}
      getOptionLabel={optionLabel}
      getOptionTag={optionLabel}
      getSelectValues={option => option.value}
      onSelectOption={selected => {
        const next = selected[0]
        if (next && next !== i18n.language) {
          preloadActiveNamespaces(next).then(() => i18n.changeLanguage(next))
        }
      }}
    />
  )
}
